export default "<p>azure-modern works!</p>\n"